import recentStores from './recentStores';

export default recentStores;
